import styled from "styled-components";

export const StyledDiscountFormWrapper = styled.div`
  background: white;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  margin-top: 1.8rem;
`;

export const StyledDiscountFormContainer = styled.div`
  background: white;
  margin-bottom: 24px;

  .form-header {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    color: #1c1726;
    margin-bottom: 16px;
  }

  .form-content {
    padding: 0 4px;
  }
`;

export const StyledDiscountFormItem = styled.div`
  margin-bottom: 12px;

  .label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    label {
      font-size: 14px;
      font-weight: 400;
      color: #1c1726;
    }
  }

  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 8px;
    padding: 10px 12px;
    border: 1px solid #f0f0f0;

    &:hover,
    &:focus {
      border-color: #d9d9d9;
      box-shadow: none;
    }
  }

  .ant-input-affix-wrapper .ant-input {
    padding: 0;
    border: none;
    background: transparent;
    box-shadow: none;
  }

  .ant-input-affix-wrapper .ant-input:focus,
  .ant-input-affix-wrapper .ant-input:hover {
    border: none;
    box-shadow: none;
  }

  .ant-form-item-explain-error {
    color: #ff4d4f;
    font-size: 13px;
    margin-top: 4px;
  }

  .ant-select-selector {
    border-radius: 8px !important;
    padding: 0 12px !important;
    border: 1px solid #f0f0f0 !important;

    &:hover,
    &:focus,
    &:focus-within {
      border-color: #d9d9d9 !important;
      box-shadow: none !important;
    }
  }

  .ant-picker {
    border-radius: 8px;
    border: 1px solid #f0f0f0;

    &:hover,
    &:focus {
      border-color: #d9d9d9;
      box-shadow: none;
    }
  }

  .ant-radio-wrapper {
    font-size: 14px;
    color: #1c1726;
  }

  .ant-checkbox-wrapper {
    font-size: 14px;
    color: #1c1726;
  }
`;

export const StyledDiscountFormButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;

  button {
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
  }

  .btn-primary {
    background: #1c1726;
    border-color: #1c1726;

    &:hover:not(:disabled) {
      background: #000;
      border-color: #000;
    }
  }

  .btn-secondary {
    background: white;
    color: #1c1726;
    border: 1px solid #222222;

    &:hover:not(:disabled) {
      border-color: #8c8c8c;
    }
  }
`;
